
export default function About() {
  return (
    <section id="sobre" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Team Photo */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/7a067549e0bcf0a16c4ff56cba04b082.jpeg"
                alt="Laginestra Lawyers Team"
                className="w-full rounded-2xl shadow-2xl object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6">
              About Laginestra
            </h2>

            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p className="text-lg">
                We were born from the need to offer differentiated social security service,
                where transparency and clear communication are the fundamental pillars of our practice.
              </p>

              <p className="text-lg">
                Our vision is to grow nationally as a reference in Social Security Law,
                always maintaining our commitment to technical excellence and close monitoring
                of each client.
              </p>

              <p className="text-lg">
                We believe that social security matters should not be complicated. Therefore,
                we translate legal complexity into simple language, ensuring that you
                understand each step of your process.
              </p>
            </div>

            <div className="mt-8 flex items-center space-x-4">
              <div className="w-12 h-12 bg-[#b86846] rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <div>
                <h4 className="text-white font-semibold">Commitment to results</h4>
                <p className="text-gray-400">Transparency at every step of the process</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
